module.exports = __webpack_public_path__ + "img/service-card-4.80bd9976.png";